import { render } from "./QuestionsAnswers.vue?vue&type=template&id=6e65cf9c"
import script from "./QuestionsAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionsAnswers.vue?vue&type=script&lang=js"

import "./QuestionsAnswers.vue?vue&type=style&index=0&id=6e65cf9c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__